import React, { useState } from "react";
import {
  FaUserCheck,
  FaTicketAlt,
  FaBlog,
  FaChalkboardTeacher,
  FaChevronDown,
  FaChevronUp,
  FaBars,
  FaTimes,
  FaClipboardList,
} from "react-icons/fa";
import { PiNetworkFill } from "react-icons/pi";
import { RiCashFill } from "react-icons/ri";
import { MdRuleFolder, MdSpaceDashboard } from "react-icons/md";
import { IoDocumentText } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import { IconType } from "react-icons/lib";
import usePendingLeaveBalanceCount from "../../hooks/usePendingLeaveBalanceCount";

interface SubMenuItem {
  label: string;
  path: string;
  visibleTo?: string[];
}

interface MenuItem {
  icon: IconType;
  label: string;
  path: string;
  subItems?: SubMenuItem[];
  visibleTo?: string[];
}

const menuItems: MenuItem[] = [
  { icon: MdSpaceDashboard, label: "Dashboard", path: "/dashboard" },
  {
    icon: PiNetworkFill,
    label: "Ecosystems",
    path: "/organization",
    visibleTo: ["HR", "manager", "SuperAdmin", "test", "Finance"],
    subItems: [
      {
        label: "Attendance Management",
        path: "/organization/attendance-management",
        visibleTo: ["manager", "SuperAdmin", "HR"],
      },
      {
        label: "Attendance Approval",
        path: "/organization/attendance-approval",
        visibleTo: ["manager", "SuperAdmin"],
      },
      {
        label: "Attendance Logs",
        path: "/organization/attendance-logs",
        visibleTo: ["HR", "manager", "SuperAdmin"],
      },
      {
        label: "Trusted Devices",
        path: "/organization/trusted-devices",
        visibleTo: ["HR", "SuperAdmin"],
      },
      {
        label: "Employee Management",
        path: "/organization/employee-management",
        visibleTo: ["HR", "SuperAdmin"],
      },
      {
        label: "Payroll Management",
        path: "/organization/payroll-management",
        visibleTo: ["HR", "SuperAdmin"],
      },
      {
        label: "New Payroll System",
        path: "/organization/new-payroll",
        visibleTo: ["HR", "SuperAdmin"],
      },
      {
        label: "Employee loans",
        path: "/organization/employee-loans",
        visibleTo: ["HR", "SuperAdmin", "Finance", "manager"],
      },
      {
        label: "Employee Letters",
        path: "/organization/employee-letters",
        visibleTo: ["HR", "manager", "SuperAdmin"],
      },
      // {
      //   label: "Payroll Finance",
      //   path: "/organization/payroll-finance",
      //   visibleTo: ["SuperAdmin", "Finance"],
      // },
      {
        label: "Vehicle Finance",
        path: "/organization/vehicle-finance",
        visibleTo: ["SuperAdmin", "Finance"],
      },
      // {
      //   label: "Finance Management",
      //   path: "/organization/finance-management",
      //   visibleTo: ["SuperAdmin", "Finance"],
      // },
      {
        label: "Leave Management",
        path: "/organization/leave-management",
        visibleTo: ["HR", "manager", "SuperAdmin"],
      },
      {
        label: "Leave Balance Requests",
        path: "/organization/leave-balance-requests",
        visibleTo: ["SuperAdmin"],
      },
      {
        label: "My Balance Requests",
        path: "/organization/leave-balance/my-requests",
        visibleTo: ["HR", "manager"],
      },
      {
        label: "Ticket Management",
        path: "/organization/ticket-management",
        visibleTo: ["HR", "manager", "SuperAdmin"],
      },
      {
        label: "Holiday Management",
        path: "/organization/holiday-management",
        visibleTo: ["HR", "SuperAdmin"],
      },
      {
        label: "User Shift Management",
        path: "/organization/user-shift-management",
        visibleTo: ["HR", "manager", "SuperAdmin"],
      },
      {
        label: "Master Data Dashboard",
        path: "/organization/master-data",
        visibleTo: ["HR", "manager", "SuperAdmin"],
      },
      {
        label: "Team Management",
        path: "/organization/team-management",
        visibleTo: ["HR", "manager", "SuperAdmin"],
      },
      {
        label: "Notice Management",
        path: "/organization/notice-management",
        visibleTo: ["HR", "SuperAdmin"],
      },
      {
        label: "Forms Management",
        path: "/organization/forms-management",
        visibleTo: ["SuperAdmin"],
      },
      {
        label: "Poll Management",
        path: "/organization/poll-management",
        visibleTo: ["SuperAdmin"],
      },
      {
        label: "Vehicle Management",
        path: "/organization/vehicle-management",
        visibleTo: ["HR", "SuperAdmin"],
      },
      {
        label: "Password Manager",
        path: "/admin/password-manager",
        visibleTo: ["SuperAdmin"],
      },
      {
        label: "Attendance Manager",
        path: "/organization/attendance-manager",
        visibleTo: ["test"],
      },
    ],
  },
  {
    icon: FaClipboardList,
    label: "Forms",
    path: "/forms",
    subItems: [
      { label: "Feedback Form", path: "/forms/feedback" },
      { label: "Suggestion Form", path: "/forms/suggestion" },
      { label: "Leave Application", path: "/forms/leave-application" },
      { label: "Track Application", path: "/forms/track-application" },
    ],
  },
  {
    icon: FaUserCheck,
    label: "Attendance",
    path: "/attendance",
    subItems: [
      { label: "View Attendance", path: "/attendance/view" },
      {
        label: "View Holidays",
        path: "/attendance/view-holidays",
      },
      {
        label: "My Update Requests",
        path: "/attendance/my-requests",
        visibleTo: ["HR", "SuperAdmin"],
      },
    ],
  },
  {
    icon: RiCashFill,
    label: "Payroll",
    path: "/payroll",
    subItems: [
      // { label: "View Payroll", path: "/payroll/view" },
      { label: "My Salary Slips", path: "/payroll/new-view" },
      { label: "My loans", path: "/payroll/my-loans" },
      { label: "Leaves Available", path: "/payroll/available-leaves" },
      { label: "Provident Fund", path: "/payroll/provident-fund" },
    ],
  },
  {
    icon: FaTicketAlt,
    label: "Tickets",
    path: "/tickets",
    subItems: [
      { label: "Attendance Ticket", path: "/tickets/attendance" },
      { label: "Network Ticket", path: "/tickets/network" },
      { label: "HR Ticket", path: "/tickets/hr" },
      { label: "Admin Ticket", path: "/tickets/admin" },
    ],
  },
  {
    icon: IoDocumentText,
    label: "Letters",
    path: "/letters",
    subItems: [
      { label: "My Letters Inbox", path: "/letters/inbox" },
      { label: "Employment Certificate", path: "/letters/employee-letter" },
      { label: "Experience Letter", path: "/letters/experience-letter" },
    ],
  },
  { icon: MdRuleFolder, label: "Policies", path: "/policies" },
  { icon: FaBlog, label: "Blog", path: "/blog" },
  { icon: FaChalkboardTeacher, label: "Training Room", path: "/training-room" },
];

interface SidebarProps {
  role: string;
}

const Sidebar: React.FC<SidebarProps> = ({ role }) => {
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const pendingLeaveBalanceCount = usePendingLeaveBalanceCount(
    role === "SuperAdmin",
  );

  const toggleMenu = (label: string) => {
    setOpenMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const isMenuActive = (item: MenuItem): boolean => {
    if (item.subItems) {
      return item.subItems.some(
        (sub) =>
          sub.path === location.pathname ||
          location.pathname.startsWith(`${sub.path}/`),
      );
    }
    return location.pathname === item.path;
  };

  // Filter menu items based on the role
  const filteredMenuItems =
    role === "Finance"
      ? menuItems.filter((item) => item.label === "Ecosystems")
      : menuItems.filter(
          (item) => !item.visibleTo || item.visibleTo.includes(role),
        );

  return (
    <>
      <button
        onClick={() => setIsSidebarOpen(true)}
        className="md:hidden top-16 left-4 z-20 fixed bg-blue-600 shadow-lg p-2 rounded-lg text-white"
      >
        <FaBars size={24} />
      </button>

      <div
        className={`fixed z-30 inset-y-0 left-0 transform bg-zinc-800 text-white rounded-none transition-transform duration-300 ease-in-out ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0 md:relative md:flex md:flex-col w-64 h-screen p-3`}
      >
        <div className="md:hidden flex justify-between items-center bg-purple-800 px-4 py-3">
          <span className="font-semibold text-white text-lg">Menu</span>
          <button
            onClick={() => setIsSidebarOpen(false)}
            className="text-white"
          >
            <FaTimes size={24} />
          </button>
        </div>
        <nav className="flex flex-col mx-auto pt-2 pb-10 w-full overflow-y-auto text-lg custom-scroll">
          {filteredMenuItems.map((item, index) => {
            const Icon = item.icon;
            const isActive = isMenuActive(item);

            return (
              <div key={index}>
                <div className="block">
                  {item.subItems ? (
                    <button
                      onClick={() => toggleMenu(item.label)}
                      className={`flex items-center justify-between w-full px-4 py-3 ${
                        isActive
                          ? "bg-sky-500"
                          : "border border-solid border-white border-opacity-10 mt-2 mb-2"
                      } rounded-md hover:bg-sky-600 transition-colors duration-200`}
                    >
                      <div className="flex items-center gap-2">
                        <Icon size={20} />
                        <span className="text-md">{item.label}</span>
                      </div>
                      <div>
                        {openMenus[item.label] ? (
                          <FaChevronUp />
                        ) : (
                          <FaChevronDown />
                        )}
                      </div>
                    </button>
                  ) : (
                    <Link to={item.path}>
                      <div
                        className={`flex items-center gap-2 px-4 py-3 mb-2 mt-2 ${
                          isActive
                            ? "bg-sky-500"
                            : "border border-solid border-white border-opacity-10"
                        } rounded-md hover:bg-sky-600 transition-colors duration-200`}
                      >
                        <Icon size={20} />
                        <span className="text-md">{item.label}</span>
                      </div>
                    </Link>
                  )}
                </div>

                {item.subItems && openMenus[item.label] && (
                  <div className="flex flex-col space-y-2 mt-2 mb-2 ml-8">
                    {item.subItems
                      .filter(
                        (subItem) =>
                          !subItem.visibleTo ||
                          subItem.visibleTo.includes(role),
                      )
                      .map((subItem, subIndex) => {
                        const isSubActive =
                          location.pathname === subItem.path ||
                          location.pathname.startsWith(`${subItem.path}/`);
                        const showLeaveBalanceBadge =
                          subItem.path ===
                            "/organization/leave-balance-requests" &&
                          pendingLeaveBalanceCount > 0;
                        return (
                          <Link to={subItem.path} key={subIndex}>
                            <div
                              className={`relative flex items-center gap-4 px-4 py-2 rounded-md ${
                                isSubActive ? "bg-sky-400" : "bg-transparent"
                              } hover:bg-sky-500 transition-colors duration-200`}
                            >
                              <span className="text-sm">{subItem.label}</span>
                              {showLeaveBalanceBadge && (
                                <span className="ml-auto bg-red-500 text-white text-xs font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1">
                                  {pendingLeaveBalanceCount}
                                </span>
                              )}
                            </div>
                          </Link>
                        );
                      })}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
      </div>

      {isSidebarOpen && (
        <div
          onClick={() => setIsSidebarOpen(false)}
          className="md:hidden z-20 fixed inset-0 bg-black bg-opacity-50"
        ></div>
      )}

      <style>{`
        .custom-scroll::-webkit-scrollbar {
          width: 0px;
          background-color: transparent;
        }
        .custom-scroll::-webkit-scrollbar-thumb {
          background-color: #6d6d6d;
          border-radius: 5px;
        }
        .custom-scroll::-webkit-scrollbar-track {
          background-color: transparent;
        }
      `}</style>
    </>
  );
};

export default Sidebar;
